<template>
  <div class="min-h-screen bg-canvas flex items-center justify-center p-8">
    <LoginForm />
  </div>
</template>

<script setup>
import LoginForm from '../components/LoginForm.vue'
</script>
